import { Component, Input } from '@angular/core';
import { BaseViewComponent, IconItem, IconSize } from '@sb/library/base';

@Component({
    selector: 'lib-icon',
    templateUrl: './icon-svg.component.html',
    styleUrls: ['./icon-svg.component.scss']
})
export class IconSvgComponent extends BaseViewComponent {
    @Input() icon!: IconItem | null;
    @Input() size: IconSize = IconSize.Medium;
    @Input() toolTipText: string = '';
    @Input() visible: boolean = true;
    @Input() qaTag: string = '';
    @Input() fill: string = '';

}
